'use client';

import { Icon } from '@/general/Icons/Icon';
import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { modalStore } from '@/stores/modalStore';

import { HeaderMenuAction } from './HeaderMenuAction';

export const HeaderMenuActionSearch: FC = () => {
  const { openModal } = modalStore(
    (state) => ({
      openModal: state.openModal,
    }),
    shallow,
  );

  return (
    <HeaderMenuAction title="Open search" data-testid="header-menu-button-search" onClick={() => openModal('search')}>
      <Icon name="search" />
    </HeaderMenuAction>
  );
};
